import React, { useRef } from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useIsOverflowing } from '@shared/hooks';
import { UiText } from '@shared/ui';

import cls from './EmployeeRegistrationStatus.module.css';

interface IEmployeeRegistrationStatusProps {
    isPending: boolean;
}

export const EmployeeRegistrationStatus = ({ isPending }: IEmployeeRegistrationStatusProps) => {
    const { t } = useTranslation();
    const statusRef = useRef<HTMLSpanElement>(null);
    const { isOverflowing } = useIsOverflowing({ elRef: statusRef });

    if (!isPending) {
        return null;
    }
    return (
        <UiText
            ref={statusRef}
            tag="span"
            classes={cn(cls.colorGreen, cls.mt, cls.ellipsisOneLine)}
            variant="caption"
            align="center"
            title={
                isOverflowing ? t('EmployerCard.return.EmployerCard.info.isPending.UiText') : null
            }
        >
            {t('EmployerCard.return.EmployerCard.info.isPending.UiText')}
        </UiText>
    );
};
